
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { IfComp } from '../../core';
import { sagas as sagasMap } from '../../map';
import { sagas as sagasMultiScene } from '../../multiscene';

import { getActions } from '../sagas';
import Coordinates from './Coordinates';
import MeasureList from './MeasureList';
import MeasureValues from './MeasureValues';
import { getExportItems } from './measureExport';

const MeasureCoordinates = ({measure}) => {
    return (
        <Stack.Item>
            <Coordinates coordinates={measure.values.coords} />
        </Stack.Item>
    );
}

const MeasurePanel = (props) => {

    const dispatch = useDispatch();
    const measureActions = getActions(dispatch);
    const mapActions = sagasMap.getActions(dispatch);
    const multiSceneActions = sagasMultiScene.getActions(dispatch);

    const measure = useSelector(state => state.measurement.measure);

    const handleDelete = () => {
        measureActions.clearMeasureList();
        mapActions.addCommand(
            'CLEAR_ALL_MEASURE',
            {}
        );
        multiSceneActions.addCommand(
            'MEASURE_CLEAR',
            {}
        )
    }

    return (
        <Stack>
            <IfComp cond={measure.values}>
                <MeasureCoordinates
                    measure={measure}
                />
                <Stack.Item>
                    <MeasureValues values={measure.values} />
                </Stack.Item>
            </IfComp>
            <Stack.Item>
                <MeasureList list={measure.measureList} />
            </Stack.Item>
            <Stack.Item align="end">
                <CommandButton
                    iconProps={{iconName: 'Delete'}}
                    text="Smazat"
                    disabled={(measure.measureList.length === 0)}
                    onClick={handleDelete}
                />
                <CommandButton
                    iconProps={{iconName: 'CloudDownload'}}
                    text="Export"
                    menuProps={{
                        items: getExportItems(
                            measure, {
                                exportCoordCsv: true,
                                exportValuesCsv: true,
                                exportMeasureJson: true
                            }
                        )
                    }}
                />
            </Stack.Item>
        </Stack>
    );
}

export default MeasurePanel;
